import { httpRequest } from "../../http";

export interface CollectionDetail {
    id: number;
    name: string;
    copy_text?: string;
    hero?: string;
}

export class CommandGetCollection {
    async run(id: string): Promise<CollectionDetail | undefined> {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/collections/${id}`;
        try {
            return await httpRequest<CollectionDetail>(url, { method: "GET" });
        } catch (error) {
            console.error("Error fetching collection:", error);
            throw error;
        }
    }
}
